import React, { useState } from "react";
import { Box, Dialog, Grid, IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import constantValues from "../../constants/constantValues";
import Label from "../Label/Label";
import ExcelOutput from "../ExcelOutPut";
import "./filePreviewTable.scss";

const { TEMPLATE_NAME, BATCH_NAME, FILE_NAME, FILE_TYPE, UPDATED_ON, PREVIEW } =
  constantValues;

const FilePreviewTable = ({ data }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogData, setDialogData] = useState({});

  const showDetails = (data) => {
    setOpenDialog(true);
    setDialogData(data);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setDialogData({});
  };

  function Row(props) {
    const { list } = props;

    return (
      <React.Fragment>
        <Grid container className="invistegator-table-data" spacing={1}>
          <Grid item xs={2} className="overflow-hidden">
            <Label
              fontSize="14px"
              fontWeight="500"
              text={list.project_name}
              wordBreak="break-all"
              textTransform="none"
            />
          </Grid>

          <Grid item xs={3} className="overflow-hidden">
            <Label
              fontSize="14px"
              fontWeight="500"
              text={list.batch_name}
              wordBreak="break-all"
              textTransform="none"
            />
          </Grid>

          <Grid item xs={3.5} className="overflow-hidden">
            <Label
              fontSize="14px"
              fontWeight="500"
              text={list.file_name}
              wordBreak="break-all"
              textTransform="none"
            />
          </Grid>
          <Grid item xs={1} className="overflow-hidden">
            <Label
              fontSize="14px"
              fontWeight="500"
              text={list?.file_type}
              wordBreak="break-all"
              textTransform="none"
            />
          </Grid>
          <Grid item xs={1.5} className="overflow-hidden">
            <Label
              fontSize="14px"
              fontWeight="500"
              text={list?.created_date}
              wordBreak="break-all"
              textTransform="none"
            />
          </Grid>

          <Grid item xs={0.5} container>
            <IconButton onClick={() => showDetails(list)}>
              <VisibilityIcon />
            </IconButton>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }

  return (
    <Box className="file-preview-container">
      <Box className="file-preview-table-wrap">
        {data?.length ? (
          <>
            <Grid container className="file-preview-tableHeader" spacing={1}>
              <Grid item xs={2}>
                <Label fontSize="14px" fontWeight="600" text={TEMPLATE_NAME} />
              </Grid>

              <Grid item xs={3}>
                <Label fontSize="14px" fontWeight="600" text={BATCH_NAME} />
              </Grid>

              <Grid item xs={3.5}>
                <Label fontSize="14px" fontWeight="600" text={FILE_NAME} />
              </Grid>
              <Grid item xs={1}>
                <Label fontSize="14px" fontWeight="600" text={FILE_TYPE} />
              </Grid>
              <Grid item xs={1.5}>
                <Label fontSize="14px" fontWeight="600" text={UPDATED_ON} />
              </Grid>

              <Grid item xs={0.5}>
                <Label fontSize="14px" fontWeight="600" text={PREVIEW} />
              </Grid>
            </Grid>

            <Grid>
              {data?.map((list, i) => (
                <Row key={list?.pre_processor_id + i} list={list} i={i} />
              ))}
            </Grid>
          </>
        ) : (
          <div className="no-data">
            <Label
              text="No Data Found"
              fontSize="16"
              fontWeight="600"
              padding="20px"
            />
          </div>
        )}
      </Box>

      {openDialog && (
        <Dialog
          maxWidth="xl"
          open={openDialog}
          onClose={handleDialogClose}
          aria-labelledby="dialog-title"
          aria-describedby="dialog-description"
          classes={{ paper: "custom-dialog-paper" }}
        >
          <ExcelOutput
            dialogData={dialogData}
            handleDialogClose={handleDialogClose}
            isViewOnly={true}
          />
        </Dialog>
      )}
    </Box>
  );
};

export default FilePreviewTable;
